import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";

export default {
  props: {
    mySpace: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      optionsData: {},
      focus: true,
    };
  },

  created() {
    EventBus.$on(`mobile-tags-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }

      this.getTags();
    });

    EventBus.$on(`mobile-tags-close`, (data) => {
      if (data.id) {
        //close overlay
        EventBus.$emit("closeOverlayPage", { id: this.$options.name });
      }
    });
  },

  methods: {
    getTags() {
      this.$axios
        .get(
          `${baseUrl}/file?file=${this.optionsData.itemData.id}&myspace=${this.mySpace}&res=full&tags=true`,
          {
            responseType: "json",
          }
        )
        .then((r) => {
          //set tags
          this.optionsData.itemData = r.data;
        });
    },
  },
};
